// AutoGenerated
export class HesapVeSesGrubuBilgiModel {
    hesapModelId!: string;
    altSesGrupModelId!: string;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}